import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Button, Col, Input, Row, Pagination } from 'antd';
import {
  YMaps,
  Map,
  Clusterer,
  Placemark,
  GeolocationControl,
  FullscreenControl,
  ZoomControl,
  TypeSelector,
  RulerControl,
} from 'react-yandex-maps';
import { FiSearch } from 'react-icons/fi';
import { useShowModal } from '../../../hooks';
import works from '../../../services/works';
import objects from '../../../services/objects';
import Spinner from '../../../components/Spinner';
import { workConstructor } from '../../../utils/workConstructor';
import RatedWork from '../../../components/Cards/TaskCard';
import Wrapper from '../../../components/Wrapper';
import Select from '../../../components/FormElements/Select';
import { AiOutlineSearch } from 'react-icons/ai';
import { FilterContainer, SearchInput } from '../Search/style';
import { Title } from '../../../components/FormElements/Select/style';
import RangePicker from '../../../components/RangePicker';
import { ConsoleSqlOutlined } from '@ant-design/icons';
import organizationService from '../../../services/organization';

export default () => {
  const { selectedDate } = useSelector((state) => state.selectedDateReducer);
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const [search, setSearch] = useState('');
  const { constructorMethod } = workConstructor();
  const [mustBeSelect, setMustBeSelect] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [objectList, setObjectList] = useState([]);
  const [objectSubList, setObjectSubList] = useState([]);
  const [organizationList, setOrganizationList] = useState([]);

  const [postData, setPostData] = useState({});
  const [worksTotal, setWorksTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize] = useState(1000);

  const dateQuery = useMemo(
    () => selectedDate.every((item) => item !== '') && selectedDate,
    [selectedDate]
  );

  const { showBlured } = useShowModal();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWorks = async () => {
    try {
      setLoading(true);
      const data = {
        startDate: selectedDate[0],
        endDate: selectedDate[1],
        status: 3,
        limit: pageSize,
        page: pageNum,
        ...postData,
      };
      if (search?.length > 0) {
        data['search'] = search;
      }
      if (postData?.objects !== undefined) {
        data['objects'] = postData.objects.split(' ');
      }
      const result = await works.getAllForMap(data);
      setWorksTotal(result.totalDocs);
      setData(result.docs);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      error('Илтимос қидириш учун аввал майдонларни тўлдиринг', 2, 'topRight');
      console.log(error);
    }
  };

  const fetchObjects = () => {
    objects
      .getAll()
      .then((resp) => setObjectList(resp))
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    fetchObjects();
    const categoryAll = categories.filter((c) => c.parent === null);
    setCategoryList(categoryAll);
    organizationService
      .getAll({
        page: 1,
        limit: 1000,
      })
      .then((resp) => {
        setOrganizationList(resp?.docs);
      })
      .catch((err) => console.error(err));
  }, [categories, regions, groups, users]);

  const filteredSubObjects = useMemo(() => {
    const data = {
      parent: postData?.parentObjects,
    };
    if (postData?.region) {
      data['region'] = postData?.region;
    }
    if (postData?.group) {
      data['group'] = postData?.group;
    }
    return data;
  }, [postData?.region, postData?.group, postData?.parentObjects]);

  useEffect(() => {
    if (postData?.parentObjects) {
      objects
        .getAllSubsList(filteredSubObjects)
        .then((subsList) => {
          setObjectSubList(subsList);
        })
        .catch((err) => console.error(err));
    }
  }, [filteredSubObjects]);

  // useEffect(() => {
  //   const postSublist = {
  //     all: "all",
  //   };
  //   objects
  //     .getAllSubsList(postSublist)
  //     .then((subsList) => {
  //       setPlaceList(subsList);
  //     })
  //     .catch((err) => console.error(err));
  // }, []);

  const handleSubCategory = (value) => {
    console.log(value);
    console.log(categories);
    const subCategoryData = categories.filter((item) => item.parent === value);
    setSubCategoryList(subCategoryData);
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const handleObject = (value) => {
    const objectId = categories.find((item) => item._id === value);
    if (objectId?.object) {
      const filteredObjects = objectList.filter(
        (item) => item._id === objectId.object
      );
      setObjectList(filteredObjects);
    }
  };
  const handleGetSubObjects = (val) => {
    if (!postData?.region) {
      setMustBeSelect(true);
    }
    if (val === undefined) {
      fetchObjects();
      setMustBeSelect(false);
    }
  };

  const fetchWorkById = async (id) => {
    try {
      setLoading(true);
      const common = { categories, regions, groups, users };
      const work = await works.getOne(id);
      const workerData = constructorMethod([work], common);
      showBlured({
        title: 'Кўриш',
        maxWidth: '85vw',
        maxHeight: '80vh',
        withHeader: false,
        body: () => (
          <div style={{ padding: '0 20px 20px 20px', textAlign: 'center' }}>
            <RatedWork
              // objectsList={placeList}
              data={workerData[0]}
              medium
              hideLocation={true}
              borderLess
            />
          </div>
        ),
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    if (
      !selectedDate.every((item) => item === '') &&
      !Object.values(postData).some((x) => x !== undefined && x !== '')
    ) {
      fetchWorks();
    }
  }, [dateQuery, postData, pageNum]);

  const handleClickPlacemark = (id) => {
    fetchWorkById(id);
  };
  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <Wrapper>
      <FilterContainer>
        <div style={{ width: '100%', padding: '20px 0' }}>
          <RangePicker />
        </div>
        <Row gutter={[10, 30]} align='bottom'>
          <Col span={5}>
            <Select
              status={mustBeSelect ? 'error' : ''}
              handleChange={(value) => {
                setPostData({ ...postData, ['region']: value });
                setMustBeSelect(false);
              }}
              options={regions}
              name='region'
              defaultVal={postData?.region}
              title='Шаҳар(туман)'
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) => {
                setPostData({ ...postData, ['group']: value });
              }}
              name='group'
              options={groups}
              defaultVal={postData?.group}
              title='Гуруҳ'
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) =>
                setPostData({ ...postData, ['organization']: value })
              }
              name='organization'
              options={organizationList}
              defaultVal={postData?.organization}
              title='Ташкилотлар'
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) => {
                setPostData({ ...postData, ['category']: value });
                handleSubCategory(value);
              }}
              options={categoryList}
              name='category'
              title='Асосий категориялар'
              defaultVal={postData?.category}
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) => {
                setPostData({ ...postData, ['subCategory']: value });
                handleObject(value);
              }}
              options={subCategoryList}
              name='subCategory'
              title='Суб категориялар'
              defaultVal={postData?.subCategory}
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) => {
                setPostData({ ...postData, ['parentObjects']: value });
                handleGetSubObjects(value);
              }}
              options={objectList}
              name='parentObjects'
              title='Асосий обектлар'
              defaultVal={postData?.parentObjects}
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) =>
                setPostData({ ...postData, ['objects']: value })
              }
              options={objectSubList}
              name='objects'
              title='Суб обектлар'
              disabled={mustBeSelect}
              objSelect={true}
              defaultVal={postData?.objects}
            />
          </Col>
          <Col
            span={8}
            style={{
              display: 'flex',
              gap: '20px',
              alignItems: 'flex-end',
            }}
          >
            <SearchInput style={{ width: '100%' }}>
              <Title level={5}>Қидирув</Title>
              <Input
                placeholder='Матн бўйича қидирув...'
                allowClear
                prefix={<FiSearch color='#CCCCCC' size={12} />}
                style={{
                  background: '#FFFFFF',
                  border: '1px solid rgba(0, 0, 0, 0.07)',
                  borderRadius: '10px',
                  height: '42px',
                  fontSize: '14px',
                  minWidth: '100px',
                }}
                onChange={handleSearch}
                value={search}
              />
            </SearchInput>
            <Button
              type='primary'
              onClick={fetchWorks}
              style={{
                height: '40px',
                background: '#3380FF',
                borderRadius: '10px',
                padding: '0 40px',
              }}
            >
              Қидириш
            </Button>
          </Col>
        </Row>
      </FilterContainer>
      {worksTotal > pageSize && (
        <Row justify='end'>
          <Col>
            <div className='pagination-footer'>
              <Pagination
                current={pageNum}
                pageSize={pageSize}
                showSizeChanger={false}
                total={worksTotal}
                onChange={(page) => setPageNum(page)}
              />
            </div>
          </Col>
        </Row>
      )}
      <YMaps
        query={{
          lang: 'ru_RU',
          apikey: 'a8f72beb-f3fd-427b-8911-4d55bb3fb3c5',
        }}
        // enterprise={true}
      >
        <div
          style={{
            width: '100%',
            height: '700px',
            // height: '100%',
            border: '1px solid rgba(0, 0, 0, 0.07)',
            borderRadius: '20px',
            overflow: 'hidden',
          }}
        >
          <Map
            defaultState={{
              center: [40.3734, 71.7978],
              zoom: 10,
              controls: [],
            }}
            width='100%'
            height='100%'
            modules={['geolocation', 'geocode']}
          >
            <Clusterer
              options={{
                preset: 'islands#invertedVioletClusterIcons',
                groupByCoordinates: false,
              }}
            >
              {data.map((item, index) => (
                <Placemark
                  key={index}
                  geometry={[item.lat, item.lng]}
                  onClick={() => handleClickPlacemark(item._id)}
                />
              ))}
            </Clusterer>
            <RulerControl />
            <GeolocationControl />
            {/* <SearchControl /> */}
            <FullscreenControl />
            <ZoomControl />
            <TypeSelector />
          </Map>
        </div>
      </YMaps>
    </Wrapper>
  );
};
